import {Moarify} from '@programming/moarify';

export function initIdxLinks() {

  new Moarify({
    perPage: 10,
    totalItems: $('#idx-links-list').attr('data-total-items'),
    infiniteScroll: true,
    appendTo: $('#idx-links-list')
  });

}
